import { useToast } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { FormEvent, useState } from 'react'
import writeXlsxFile, { Row, SheetData } from 'write-excel-file'
import { get } from '../../../lib/http'
import extractDataForm from '../../../utilities/extractDataForm'

import { DataForm, ReportSalesTipsByWaiter } from './types'

export default function usePrintSalesTipsByWaiter() {
    const toast = useToast()
    const [isLoading, setIsLoading] = useState(false)

    const head: (...values: string[]) => Row[number][] = (...values) =>
        values.map<Row[number]>(val => ({
            value: val,
            fontWeight: 'bold',
            wrap: true,
            alignVertical: 'center',
            align: 'left',
            fontSize: 11
        }))

    function setDataSalesTipsByWaiter(
        data: ReportSalesTipsByWaiter[],
        rows: SheetData
    ) {
        data.forEach(item => {
            rows.push([
                {
                    value: item.waiter,
                    type: String
                },
                {
                    value: item.total,
                    type: Number,
                    align: 'right',
                    format: '#,##0.00'
                },
                {
                    value: item.tips,
                    type: Number,
                    align: 'right',
                    format: '#,##0.00'
                }
            ])
        })
    }

    async function submit(ev: FormEvent<HTMLFormElement>) {
        ev.preventDefault()
        const form = extractDataForm<DataForm>(ev.target)
        const startDate = dayjs
            .tz(form.startDate + ' 00:00:00', 'America/Lima')
            .toISOString()
        const endDate = dayjs
            .tz(form.endDate + ' 23:59:59', 'America/Lima')
            .toISOString()

        const rows: SheetData = [
            [],
            [
                {
                    value: 'Reporte de Ventas y Propinas por Meser@',
                    fontWeight: 'bold',
                    span: 3,
                    alignVertical: 'center',
                    align: 'center',
                    fontSize: 16
                }
            ],
            [
                {
                    value: `De: ${dayjs(startDate).format(
                        'DD/MM/YYYY'
                    )} - Hasta ${dayjs(endDate).format('DD/MM/YYYY')}`,
                    span: 3,
                    align: 'center'
                }
            ],
            [],
            head(
                ...['Meser@', 'Total de Ventas (S/)', 'Total de Propinas (S/)']
            )
        ]

        setIsLoading(true)

        const { data, error } = await get<ReportSalesTipsByWaiter[]>(
            `/api/reports/sales_tips_by_waiter?start_date=${startDate}&end_date=${endDate}`
        )

        if (error) {
            toast({
                title: 'Hubo un error al cargar los datos',
                status: 'error',
                position: 'top'
            })
            return
        }

        setDataSalesTipsByWaiter(data.result, rows)

        await writeXlsxFile(rows, {
            fileName: `Reporte_de_ventas_y_propinas_por_meser@_${dayjs(
                startDate
            ).format('DD/MM/YYYY')}_${dayjs(endDate).format(
                'DD/MM/YYYY'
            )}.xlsx`,
            columns: [40, 40, 12, 12].map(width => ({
                width
            })),
            fontSize: 10,
            fontFamily: 'Calibri'
        })

        setIsLoading(false)
    }

    return {
        submit,
        isLoading
    }
}
